import UIViewController from 'UIComponents/input/UIViewController';
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiButtonToggle = ({
  onChangeHandler,
  buttonOptions,
  value
}) => {
  return /*#__PURE__*/_jsx(UIViewController, {
    onChange: onChangeHandler,
    options: buttonOptions,
    value: value
  });
};
MultiButtonToggle.displayName = 'MultiButtonToggle';